import { Injectable } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import {
    NestedFormGroupType,
    FormGroupType,
} from '../../../../../../core/models/form-group-type';
import { EmissionDesignator } from '../../models/emission-designator';
import { EmissionDesignatorFormService } from '../emission-designator-form/emission-designator-form.service';
import { DropdownOption } from '../../../../../../core/models/dropdown-option';
import { FrequencyFormModel } from '../../models/frequency-form-model';

@Injectable({
    providedIn: 'root',
})
export abstract class BaseEmissionDesignatorOperationFormService<T> {
    constructor(
        protected readonly emissionDesignatorFormService: EmissionDesignatorFormService,
    ) {}

    abstract getFormDefinition(): FormGroup<NestedFormGroupType<T>>;

    abstract getUniqueEmissionDesignatorsFromAllFrequencies(
        frequencies: FormGroup<NestedFormGroupType<FrequencyFormModel>>[],
    ): EmissionDesignator[];

    abstract getFilteredDeleteEmissionDesignatorAutoCompleteOptions(
        value: string,
        frequencies: FormGroup<NestedFormGroupType<FrequencyFormModel>>[],
        formArray: FormArray<FormGroup<FormGroupType<EmissionDesignator>>>,
    ): DropdownOption[];

    abstract getDeleteEmissionDesignatorDropdownOptions(
        frequencies: FormGroup<NestedFormGroupType<FrequencyFormModel>>[],
        formArray: FormArray<FormGroup<FormGroupType<EmissionDesignator>>>,
    ): DropdownOption[];
}
